var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.93332 23.0333C7.93332 23.3095 8.15718 23.5333 8.43332 23.5333H19.5667C19.8428 23.5333 20.0667 23.3095 20.0667 23.0333V22.3C20.0667 22.0239 19.8428 21.8 19.5667 21.8H8.43332C8.15718 21.8 7.93332 22.0239 7.93332 22.3V23.0333ZM14 20.0667C15.3791 20.0667 16.7018 19.5188 17.6769 18.5436C18.6521 17.5684 19.2 16.2458 19.2 14.8667V8.43335C19.2 8.15721 18.9761 7.93335 18.7 7.93335H17.5333C17.2572 7.93335 17.0333 8.15721 17.0333 8.43335V14.8667C17.0333 15.6712 16.7137 16.4427 16.1449 17.0116C15.576 17.5804 14.8045 17.9 14 17.9C13.1955 17.9 12.424 17.5804 11.8551 17.0116C11.2862 16.4427 10.9667 15.6712 10.9667 14.8667V8.43335C10.9667 8.15721 10.7428 7.93335 10.4667 7.93335H9.29999C9.02384 7.93335 8.79999 8.15721 8.79999 8.43335V14.8667C8.79999 16.2458 9.34784 17.5684 10.323 18.5436C11.2982 19.5188 12.6209 20.0667 14 20.0667Z",
    fill: "#050022"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.fc6d95b0d1221bbb229c5e057e186186.svg";
export { ForwardRef as ReactComponent };